import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

declare global {
  interface Window {
    OnetrustActiveGroups?: string;
    loadGTM?: () => void;
  }
}

const ScriptInjector = () => {
  useEffect(() => {
    const script = document.createElement('script');
    let onetrustKeyUri = 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
    if (ONETRUST_KEY) {
      if (ONETRUST_KEY_URI) onetrustKeyUri = ONETRUST_KEY_URI

      script.src = onetrustKeyUri;
      script.async = true;
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('charset', 'UTF-8');
      script.setAttribute('data-domain-script', ONETRUST_KEY ?? '');
      document.body.appendChild(script);
      console.log('%c%s', 'color: green;', 'ONETRUST SCRIPT LOAD');
    }

    return () => {
      if (ONETRUST_KEY) {
        document.body.removeChild(script);
      }
    };
  }, []);

  if (!ONETRUST_KEY) return null

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          function OptanonWrapper() {
            console.log('%c%s', 'color: blue;', 'OptanonWrapper called');
            console.log('Active groups:', window.OnetrustActiveGroups);
            const activeGroups = window.OnetrustActiveGroups || '';
            const hasPerformanceCookies = activeGroups.includes('C0002');
            const hasTargetingCookies = activeGroups.includes('C0004');

            if (hasPerformanceCookies || hasTargetingCookies) {
              console.log('%c%s', 'color: green;', 'Consent granted for analytics/marketing - Loading GTM');
              if (window.loadGTM) {
                window.loadGTM();
              }
            } else {
              console.log('%c%s', 'color: orange;', 'No consent for analytics/marketing - GTM blocked');
            }
          }      
        `}
      </script>
    </Helmet>
  )
};

export default ScriptInjector;